import { ElectionState } from '../../_generatedTypes.g';
import { api, ReadAs } from '../../api';
import { SaveChangesResult } from '../ui/InlineFormItem';
import { UnknownAction, Dispatch } from 'redux';
import { newElectionErrorsSet } from '../../features/home/homeSlice';
import { voterEntityStateRefreshed } from '../../features/innerState/innerStateSlice';

export const pushNewElectionToServer = async (election: Partial<ElectionState> & { Code: string }, token: string, dispatch: Dispatch<UnknownAction>): Promise<SaveChangesResult> => {
    return await api(token).Elections.Add<SaveChangesResult>(election)
        .ok(fullFreshEntityState => {
            dispatch(voterEntityStateRefreshed(fullFreshEntityState));
            return { success: true };
        }, ReadAs.Json)
        .anyStatus(errors => {
            dispatch(newElectionErrorsSet(errors));
            return { success: false, errors };
        }, ReadAs.ValidationErrors)
        .fail(() => ({ success: false, errors: [] }));
}
